import React from 'react';
import { toast } from 'react-toastify';
import { FormControl } from 'react-bootstrap';

export class CopyGroupDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orderGuideGroups: [],
            currGroupId: null
        };
    }

    componentDidMount = async (props) => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };
        const response = await fetch('api/orderguidegroups', fetchConfig);
        if (response.ok) {
            let data = await response.json();
            let orderGuideGroupId = this.props.orderGuideGroupId;

            let availableGroups = data.filter(function (n) { return n.orderGuideGroupId !== orderGuideGroupId; });

            this.setState({ orderGuideGroups: availableGroups, currGroupId: this.props.orderGuideGroupId });
        }
        else {
            toast.error("Error retrieving Order Guide Groups.");
            console.log("Error retrieving Order Guide Groups: " + await response.text());
        }
    }

    render() {
        return (
            <div style={{ display: 'inline-block', marginRight: '10px', width: '250px' }} >
                <FormControl
                    componentClass="select"
                    name={this.props.name}
                    onChange={this.props.onChange}
                >
                    <option value="">--Select--</option>
                    {this.state.orderGuideGroups.map((ogg) =>
                        <option key={ogg.orderGuideGroupId} value={ogg.orderGuideGroupId}>{ogg.orderGuideGroupName.length > 30 ? `${ogg.orderGuideGroupName.substring(0, 30)}...` : ogg.orderGuideGroupName}</option>
                    )}
                </FormControl>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/CopyGroupDropdown.js